var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-body"},[_c('div',{staticClass:"l-menu",on:{"click":function($event){return _vm.taskEvent(_vm.taskFlag)}}},[_vm._v("战绩点评")]),(_vm.isRead)?_c('div',{staticClass:"l-red"}):_vm._e(),_c('LTask',{attrs:{"options":_vm.taskFlag,"list":_vm.listData},on:{"closeTask":function($event){return _vm.taskEvent(_vm.taskFlag)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }